module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-right-square-88d18af8.svg";